import PropTypes from 'prop-types';
import NoticeIcon from '../../inline-images/notice-icon.svg';

/**
 * @summary The header noticebar.
 * @returns {JSX.Element}
 */
export default function HeaderNotice({ noticeMessage }) {
	return (
		<>
			<div className="header-notice">
				<div className="notice-icon">
					<NoticeIcon />
				</div>
				<div className="notice-message">
					{noticeMessage}
				</div>
			</div>
		</>
	);
}

HeaderNotice.propTypes = {
	noticeMessage: PropTypes.string.isRequired,
};
